exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1wh3g_eLa97bS8{min-height:600px}._2eue2Szzmg-UzM{align-items:center;background-color:#e4f0f6;display:flex;justify-content:space-between;padding:8px 8px 8px 16px}._1XLxOgEYO2XLep{color:#172b4d;font-size:16px;font-weight:600;letter-spacing:-.006em;line-height:20px;margin-top:24px;margin:0}._2DlRXHefLZeYni{display:flex;column-gap:8px}._27i3khqubTi2nK,.eipsAuGItc7Ub5{margin:0}", ""]);

// exports
exports.locals = {
	"mirrorCard": "_1wh3g_eLa97bS8",
	"banner": "_2eue2Szzmg-UzM",
	"bannerText": "_1XLxOgEYO2XLep",
	"bannerButtons": "_2DlRXHefLZeYni",
	"viewOriginalCardButton": "_27i3khqubTi2nK",
	"closeButton": "eipsAuGItc7Ub5"
};